import { useEffect, useRef, useState } from 'react';
import useCustomSpeechRecognition from '../useCustomSpeechRecognition';

const useHandleSpeechRecognitionOutput = (
  UiValue,
  setUiValue
) => {
  const cachedValue = useRef('');

  const {
    transcript,
    isListening,
    startListening,
    stopListening,
  } = useCustomSpeechRecognition();

  useEffect(() => {
    if (isListening) {
      if (transcript.length > 0) {
        setUiValue(transcript);
      }
    } else {
      stopListening();
    }
  }, [transcript, isListening]);

  return [
    transcript,
    isListening,
    startListening,
    stopListening,
  ];
};

export default useHandleSpeechRecognitionOutput;
